import React from 'react';
import { Link } from 'react-router-dom';
import logoXCoin from '../assets/logo_plateado.png'; // Asegúrate de tener la ruta correcta

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page-wrapper" style={{ padding: '40px', maxWidth: '900px', margin: '0 auto', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', color: '#333' }}>
      
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <img src={logoXCoin} alt="XCoin Logo" style={{ width: '200px', marginBottom: '20px' }} />
        <h1>Política de Privacidad</h1>
        <p style={{ color: '#666' }}>Última actualización: Noviembre 2025</p>
      </div>

      <div className="privacy-content">
        <section style={{ marginBottom: '20px' }}>
          <h3>1. Introducción</h3>
          <p>
            Bienvenido a XCoin ("nosotros", "nuestro" o "la Plataforma"). Nos tomamos muy en serio su privacidad. 
            Esta Política de Privacidad describe cómo recopilamos, usamos, procesamos y protegemos su información personal 
            cuando utiliza nuestro sitio web (xcoin.cl, dashboard.xcoin.cl) y nuestros servicios.
          </p>
        </section>

        <section style={{ marginBottom: '20px' }}>
          <h3>2. Información que Recopilamos</h3>
          <p>Para brindarle nuestros servicios, podemos recopilar los siguientes tipos de información:</p>
          <ul>
            <li><strong>Información de Identificación Personal:</strong> Nombre completo, RUT o número de pasaporte, dirección de correo electrónico, número de teléfono, dirección física y fecha de nacimiento.</li>
            <li><strong>Información de Redes Sociales:</strong> Si decide registrarse o iniciar sesión a través de terceros (Google, Facebook), recopilamos su nombre, dirección de correo electrónico y foto de perfil asociada a esa cuenta.</li>
            <li><strong>Información Financiera:</strong> Datos necesarios para procesar transacciones, como historiales de depósitos y retiros (no almacenamos datos sensibles de tarjetas de crédito directamente; estos son procesados por proveedores de pago seguros).</li>
            <li><strong>Datos Técnicos:</strong> Dirección IP, tipo de navegador, sistema operativo y datos de uso de la plataforma.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '20px' }}>
          <h3>3. Uso de la Información</h3>
          <p>Utilizamos su información para los siguientes fines:</p>
          <ul>
            <li>Proveer, operar y mantener nuestra plataforma de intercambio.</li>
            <li>Procesar sus transacciones y gestionar su billetera digital.</li>
            <li>Verificar su identidad para cumplir con regulaciones legales (KYC/AML).</li>
            <li>Mejorar, personalizar y expandir nuestros servicios.</li>
            <li>Comunicarnos con usted, incluyendo servicio al cliente, actualizaciones y notificaciones de seguridad.</li>
            <li>Prevenir fraudes y garantizar la seguridad de nuestra plataforma.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '20px' }}>
          <h3>4. Compartir Información con Terceros</h3>
          <p>
            No vendemos, comercializamos ni alquilamos su información personal a terceros. Solo compartimos información cuando es necesario para:
          </p>
          <ul>
            <li>Cumplir con leyes, regulaciones o procesos legales aplicables en Chile.</li>
            <li>Procesadores de pagos y proveedores de servicios tecnológicos que nos ayudan a operar nuestro negocio (bajo acuerdos de confidencialidad).</li>
          </ul>
        </section>

        <section style={{ marginBottom: '20px' }}>
          <h3>5. Instrucciones para la Eliminación de Datos (Derechos ARCO)</h3>
          <p>
            De acuerdo con la legislación vigente y las políticas de plataformas como Facebook, usted tiene derecho a acceder, rectificar, cancelar u oponerse al tratamiento de sus datos.
          </p>
          <p>
            <strong>Para solicitar la eliminación de su cuenta y sus datos:</strong>
          </p>
          <ol>
            <li>Envíe un correo electrónico a <a href="mailto:gerencia@xcoin.cl">gerencia@xcoin.cl</a>.</li>
            <li>Utilice el asunto: "Solicitud de Eliminación de Datos".</li>
            <li>Incluya su nombre de usuario y el correo electrónico asociado a la cuenta.</li>
          </ol>
          <p>
            Procesaremos su solicitud en un plazo máximo de 10 días hábiles, eliminando su información de nuestros sistemas activos, salvo aquella que debamos conservar por obligaciones legales (como registros de transacciones financieras).
          </p>
        </section>

        <section style={{ marginBottom: '20px' }}>
          <h3>6. Seguridad de los Datos</h3>
          <p>
            Implementamos medidas de seguridad técnicas y organizativas (como encriptación SSL y autenticación de dos factores) para proteger sus datos personales contra el acceso no autorizado, la alteración, la divulgación o la destrucción.
          </p>
        </section>

        <section style={{ marginBottom: '20px' }}>
          <h3>7. Cambios a esta Política</h3>
          <p>
            Podemos actualizar nuestra Política de Privacidad periódicamente. Le notificaremos cualquier cambio publicando la nueva política en esta página y actualizando la fecha de "Última actualización".
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h3>8. Contacto</h3>
          <p>
            Si tiene preguntas sobre esta Política de Privacidad, puede contactarnos en: <br />
            <strong>Email:</strong> gerencia@xcoin.cl <br />
            <strong>Sitio Web:</strong> www.xcoin.cl
          </p>
        </section>

        <div style={{ textAlign: 'center', borderTop: '1px solid #eee', paddingTop: '20px' }}>
            <Link to="/" className="btn btn-primary" style={{ padding: '10px 20px', textDecoration: 'none', background: '#333', color: '#fff', borderRadius: '5px' }}>
              Volver al Inicio
            </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;